import { createActions } from 'redux-actions';
import { request } from '../../services';


const {
    createMergedPhasesRequest,
    createMergedPhasesSuccess,
    createMergedPhasesFailure,
  } = createActions({
    CREATE_MERGED_PHASES_SUCCESS: (json, relatedPhaseId) => ({
      message: json.message,
      relatedPhaseId,
    }),
  }, 'CREATE_MERGED_PHASES_REQUEST', 'CREATE_MERGED_PHASES_FAILURE');

export function createMergedPhases(phaseId, relatedPhaseId) {
  return (dispatch) => {
    dispatch(createMergedPhasesRequest());

    const req = { method: 'POST', body: { related_phase_id: relatedPhaseId } };
    return request(`phases/${phaseId}/merged_phases`, req)
    .then(({ json }) =>
        dispatch(createMergedPhasesSuccess(json, phaseId)),
    )
    .catch(error => dispatch(createMergedPhasesFailure(error)));
  };
}



// WEBPACK FOOTER //
// ./client/app/shared/actionCreators/merged_phases.js